import { render } from "./ProductVariants.vue?vue&type=template&id=5a351e41"
import script from "./ProductVariants.vue?vue&type=script&lang=js"
export * from "./ProductVariants.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/ProductVariants/ProductVariants.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5a351e41"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5a351e41', __exports__)) {
    api.reload('5a351e41', __exports__)
  }
  
  module.hot.accept("./ProductVariants.vue?vue&type=template&id=5a351e41", () => {
    api.rerender('5a351e41', render)
  })

}


export default __exports__